import { Static, Type } from '@sinclair/typebox';
import { makeNullable } from '../../utils/typeboxHelpers';

export const surveyPointCloudTableSchema = Type.Object({
    id: Type.String({ format: 'uuid' }),
    surveyId: Type.String({ format: 'uuid' }),
    /** The original file name of the point cloud */
    filename: makeNullable(Type.String({ maxLength: 255 })),
    /** Id (name) of the directory in S3 where the files are stored */
    storageId: Type.String({ maxLength: 255 }),
    isVisible: Type.Boolean(),
    /** Total byte size on S3 for point cloud */
    pointCloudStorageUsed: Type.Number(),
    /** View type. Can be: RGB, Elevation or Intensity. */
    display: Type.String({ maxLength: 255 }),
    created_at: makeNullable(Type.String()),
    updated_at: makeNullable(Type.String()),
    /** The RGB temperature range starts at a blue color. */
    startTemperatureRange: makeNullable(Type.Number()),
    /** The RGB temperature range end at a red color. */
    endTemperatureRange: makeNullable(Type.Number()),
    /** Entry point */
    indexFilename: Type.String({ maxLength: 255 }),
});

/** Point cloud used in a survey */
export type SurveyPointCloud = Static<typeof surveyPointCloudTableSchema>;
